<template>
    <div>
         <div>
            <h5>Change your password!</h5>
            <p class="text-muted my-3">
                Enter a new password for your account. After that you will be able to login with this password.
            </p>
        </div>
        <form name="reset" class="py-5 my-md-5" @submit.prevent="changePassword">
            <div class="form-group">
                <label>New Password</label>
                <input type="password" placeholder="New password" v-model="newPassword" class="form-control" required>
            </div>
            <button type="submit" class="btn btn-primary btn-block">Set Password</button>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            newPassword: '',
        }
    },

    methods: {
        changePassword() {
            const token = this.$route.query.token;
            const path = process.env.API_LOCATION + `/validate_reset_password`;

            this.$http.post(path, {
                token: token,
                password: this.newPassword
            })
            .then(response => {
                this.$router.push("/login");
                this.$emit("success", "Successfully changed password!");
            })
            .catch(error => {
                this.$router.push("/login");
                this.$emit("error", "Unable to change password. Invalid token.");
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/ChangePassword.vue